import React from 'react';
import styled from 'styled-components';
import { fontGraphie } from '../../../fonts/mixin';
import TeacherDiscountLogo from './teacher-discount-logo';
import { TEACHER_DISCOUNT_PERCENTAGE } from '../../constant-data/constants';
import { white } from '../loggedout/shared-styles/Colors';

var timeOutId;
const TeacherDiscount = () => {
  const logoColor = "#c20f03";
  return (
    <DiscountWrapper>
      <ImageContainer>
        <Banner>
        <TeacherDiscountLogo color={logoColor}></TeacherDiscountLogo>
        </Banner>
        <BannerText>{TEACHER_DISCOUNT_PERCENTAGE}</BannerText>
        <BannerText>off</BannerText>
      </ImageContainer>
      <TextContainer>
        <ShimmerContainer />
        <RefferralText>
        applied via Teacher Referral
        </RefferralText>
      </TextContainer>
    </DiscountWrapper>
  );
}

const DiscountWrapper =styled.div`
  display: flex;
  align-items: center;
`
const ImageContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 6.3rem;
  height: 5.9rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${fontGraphie(1.6, 1.6, 7)};
  color: ${white};
`;

const Banner = styled.div`
  position: absolute;
  width: 100%;
  height: fit-content;
`
 const BannerText = styled.div`
  position: relative;
  z-index: 1;
`

const TextContainer = styled.div`
  position: relative;
  width: max-content;
  left: -1rem;
  padding: 0.2rem 0.8rem 0.2rem 1.4rem;
  border-radius: 0 0.6rem 0.6rem 0;
  background-color: #FFDDDB;
  ${fontGraphie(2.4, 1.6, 6)};
  color: #C20F03;
  animation: badgeAnimation 2.2s;

  @keyframes badgeAnimation {
    0% {
      background-color: #f1dafa;
      color: #b746e6;
    }
    100% {
      background-color: #FFDDDB;
      color: #C20F03;
    }
  }
`;

const ShimmerContainer = styled.div`
  position: absolute;
  z-index: 3;
  width: 6%;
  height: 100%;
  top: 0;
  left: 0;
  transform: skewX(-21deg);
  animation :  shimmerEffect 2.2s linear; 
  background-color: #fff;
  filter: blur(10px);
  opacity: 0;
  @keyframes shimmerEffect {
    0% {
     left: 0%;
     opacity: 1;
    }
    100% {
      left: 90%;
      opacity: 1;
    }
  }
`

const RefferralText =styled.div`
  position: relative;
  z-index: 4;
`;


export default TeacherDiscount;